import { Typography, Container } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AboutTeam() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      // If no hash, scroll to top immediately
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000000ff',
      // background: 'linear-gradient(105deg, #050505ff 60%, #414345 100%)',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <Container sx={{ py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom 
          style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '4rem', fontWeight: 500, marginTop: '80px', textAlign: 'center' }}>
          About Us
        </Typography>
        <Typography variant="body1" paragraph
         style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', fontWeight: 500, marginTop: '40px', textAlign: 'left', minWidth: '1150px' }}>
          Digital Operating is a group of geoscientists, engineers, and tax professionals who are passionate about bringing
          complex problems into a new digital era.  Whether it be for subsurface analisys, tax appraisals, or oil & gas accounting,
          we want to streamline processes by leveraging AI and automation to eliminate tedious, manual tasks and put power back
          into the hands of our clients.<br /><br />Furthermore, having been
          geoscientists who have fought the battle of budgets, we don't want to gouge our clients just because they're
          "oil companies with deep pockets" or "mineral owners who must be rich". Whether you're an independent, an employee of a multi-national,
          or the owner of a small mineral interest, we've been on the same frontlines that you, our clients, are currently on.  
          We know the realities of budgets and contractor costs.
          <br /><br />This is why we are committed to bringing our solutions to the industry at a price point that is 
          too good to pass up on.  We achieve this by leveraging over 60 years of collective geoscience
           and operational experience with more than 15 years of AI and software development experience.<br /><br />
        </Typography>
        
        {/* Team members in a single row */}
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', maxWidth: '1400px', 
         marginTop: '120px', gap: '90px', minWidth: '1150px'}}>
          {/* Eduardo Gonzales */}
          <div style={{ flex: 1, textAlign: 'left', maxWidth: '350px' }}>                     
            <img src="/Ed-Headshot.jpg" alt="Ed Headshot" style={{ display: 'block', margin: '0 auto 20px auto', maxWidth: '250px', width: '100%', height: '300px', objectFit: 'cover', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
            <Typography variant="h5" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.1255rem', fontFamily: 'Inter, sans-serif', fontWeight: 700, whiteSpace: 'nowrap' }}>
              Eduardo Gonzales
            </Typography>   
            <Typography variant="h6" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 500, whiteSpace: 'nowrap' }}>
              Founder
            </Typography>            
            <Typography variant="h7" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 500, whiteSpace: 'nowrap', fontStyle: 'italic' }}>
              M.S. Geoscience<br /><br />
            </Typography>
            <div
             style={{width: '100%', maxWidth: '300px', height: '1px', background: '#a4fdffff', opacity: 0.9, margin: '12px 0' }} />
            <Typography variant="body1" paragraph
            style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', fontWeight: 500, textAlign: 'left', marginTop: '30px' }}>
              Ed is an operational geoscientist with experience in basins across the globe including the Permian Basin, Central Basin Platform.
            </Typography>
          </div>
          {/* Fraser Robinson */}
          <div style={{ flex: 1, textAlign: 'left', maxWidth: '350px' }}>                
            <img src="/Fraser-Headshot.jpg" alt="Fraser Headshot" style={{ display: 'block', margin: '0 auto 20px auto', maxWidth: '250px', width: '100%', height: '300px', objectFit: 'cover', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
            <Typography variant="h5" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.1255rem', fontFamily: 'Inter, sans-serif', fontWeight: 700, whiteSpace: 'nowrap' }}>
              Fraser Robinson
            </Typography>        
            <Typography variant="h6" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 500 }}>
              Founder
            </Typography>
            <Typography variant="h7" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 500, maxWidth: '300px', margin: '0 auto', marginBottom: '16px', whiteSpace: 'nowrap', fontStyle: 'italic' }}>
              MEng Aerospace Eng & Astronautics<br /><br />
            </Typography>
            <div
             style={{width: '100%', maxWidth: '300px', height: '1px', background: '#a4fdffff', opacity: 0.9, margin: '12px 0'}} />
            <Typography variant="body1" paragraph
            style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.25rem', fontWeight: 500, textAlign: 'left', marginTop: '30px' }}>
              Fraser is a software developer with over 15 years of experience building AI solutions and software applications.
            </Typography>
          </div>
          {/* Alexander Gonzales */}
          <div style={{ flex: 1, textAlign: 'center', maxWidth: '350px' }}>                       
            <img src="/Alex_Headshot.jpg" alt="Alex Headshot" style={{ display: 'block', margin: '0 auto 20px auto', maxWidth: '250px', width: '100%', height: '300px', objectFit: 'cover', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
            <Typography variant="h5" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 700, whiteSpace: 'nowrap' }}>
              Alexander Gonzales
            </Typography> 
            <Typography variant="h6" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 500, whiteSpace: 'nowrap' }}>
              Founder
            </Typography>
            <Typography variant="h6" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 500, maxWidth: '300px', whiteSpace: 'nowrap' }}>
              M.S. Geoscience, M.B.A., M.S. Energy Mgmt
            </Typography>
            <Typography variant="h6" style={{ color: '#ffffffff', textAlign: 'left', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', fontWeight: 500, maxWidth: '300px' }}>
              R.P.A. # 77930
            </Typography>
            <div
             style={{width: '100%', maxWidth: '375px', height: '1px', background: '#a4fdffff', opacity: 0.9}} />
            <Typography variant="body1" paragraph
            style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', fontWeight: 500, textAlign: 'left', marginTop: '30px'  }}>
              Alexander is a Geoscientist and Tax Appraiser with a passion for leveraging technology to solve complex problems.
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
}
